//Lib 
import { mapState } from "vuex";

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant  
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE } from "@/constant/extraService";

// Component  

export default {

    extends: baseExtraService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    data() {

        return {
            imageThreshold: 0,
            note: null,
        };
    },

    mounted() {
        this.imageThreshold = this.user.imageThreshold;
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD);
        },
        //#endregion

        //#region Expand image threshold send request
        send() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: EXTRA_SERVICE_TYPE.EXPAND_IMAGE_THRESHOLD,
                    imageThreshold: this.imageThreshold,
                    note: this.note,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.createRequest(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}